// ==============================|| MENU ITEMS - BANNER ROUTES ||============================== //

// icons
import LiveTvIcon from '@mui/icons-material/LiveTv';

const LiveRoutes = {
  id: 'Live-group',
  title: 'Live Management',
  type: 'group',
  children: [
    {
      id: 'Live-list',
      title: 'Live List',
      type: 'item',
      url: '/live/list',
      icon: LiveTvIcon,
      target: false
    }
  ]
};

export default LiveRoutes;
